import React, { Component } from "react";
import SidePageHeader from "../Common/SidePageHeader/SidePageHeader";
import { goBack } from "react-router-redux";
import { connect } from "react-redux";
import styles from "./ExtraSlides.local.scss";
import {
  setCurrentNavPage,
  setExtraSlideListPaginationPage,
  setVisibilityExtraSlide,
  setSearchTitleExtraSlide,
  setCategorySelectedItem
} from "Actions";
import { fetchExtraSlideList, fetchCategoryExtraSlideList } from "Thunks";
import _ from "i18n";
import ExtraSlideList from "./ExtraSlideList";
import classnames from "classnames";
import TTPPaginator from "../Common/TTPPaginator";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import { VISIBILITY_OPTIONS } from "../../config";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";
import { SettingIconTwo } from "../Common/Icons";

import CategorySettingContent from "./CategorySettingContent";
import TTPModal from "../Common/Modal/TTPModal";

class ExtraSlidesContentPage extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      categoryDivIsVisible: false,
      isCategoryModalVisible: false,
      loading: false
    };
    this.visibilityOptions = VISIBILITY_OPTIONS.map(({ label, value }) => {
      return { label: label, value: value };
    });
  }

  componentDidMount() {
    const { dispatch, extraSlidesInModal } = this.props;

    if (extraSlidesInModal) {
      dispatch(setVisibilityExtraSlide("0"));
      dispatch(fetchExtraSlideList("0"));
    } else {
      dispatch(setCurrentNavPage("EXTRA_SLIDES_SETTING"));
      dispatch(setVisibilityExtraSlide("-1"));
      dispatch(fetchExtraSlideList());
    }

    dispatch(fetchCategoryExtraSlideList());

    document.addEventListener(
      "mousedown",
      this.handleClickOutsideSelectFrame.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      visibility,
      searchTitle,
      categoryListSelected,
      dispatch
    } = this.props;
    const { paginationPage, pageSize } = prevProps;
    if (
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      dispatch(
        fetchExtraSlideList(visibility, searchTitle, categoryListSelected)
      );
    }

    if (prevProps.searchTitle !== searchTitle && searchTitle === "") {
      this.child.current.childBox.current.clearInput();
    }
  }

  handleExtraSlideListPageChange = ({ selected }) => {
    this.props.dispatch(setExtraSlideListPaginationPage(selected + 1));
  };
  renderPaginate() {
    let { extraSlides, paginationPage, pageSize, nbResult } = this.props;
    if (extraSlides.error != null && extraSlides.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleExtraSlideListPageChange}
        pageSize={pageSize}
        nbResult={nbResult}
        paginationPage={paginationPage}
      />
    );
  }
  handleGoBack = () => {
    this.props.dispatch(goBack());
  };

  handleSearchInputChange = word => {
    const { dispatch, visibility, categoryListSelected } = this.props;
    dispatch(setSearchTitleExtraSlide(word));
    dispatch(fetchExtraSlideList(visibility, word, categoryListSelected));
    dispatch(setExtraSlideListPaginationPage(1));
  };

  handleSelectVisibility = selected => {
    const { dispatch, searchTitle, categoryListSelected } = this.props;
    dispatch(setVisibilityExtraSlide(selected));
    dispatch(fetchExtraSlideList(selected, searchTitle, categoryListSelected));
    dispatch(setExtraSlideListPaginationPage(1));
  };

  handleDeselectCategory = id => {
    let { selectedCategories, dispatch, visibility, searchTitle } = this.props;

    let newSelectedItems = [...selectedCategories];
    if (selectedCategories.includes(id)) {
      newSelectedItems.splice(newSelectedItems.indexOf(id), 1);
    } else {
      newSelectedItems.push(id);
    }
    dispatch(setCategorySelectedItem(newSelectedItems));
    dispatch(setExtraSlideListPaginationPage(1));
    dispatch(fetchExtraSlideList(visibility, searchTitle, newSelectedItems));
  };

  setSelectWrapperRef(node) {
    this.selectWrapperRef = node;
  }

  handleClickOutsideSelectFrame(event) {
    if (
      this.selectWrapperRef &&
      !this.selectWrapperRef.contains(event.target)
    ) {
      this.setState({ ...this.state, categoryDivIsVisible: false });
    }
  }
  handleDisplayCategorySelectItems = () => {
    this.setState(state => {
      return {
        ...state,
        categoryDivIsVisible: !state.categoryDivIsVisible
      };
    });
  };
  handleDisplayCategoryModal = () => {
    this.setState({
      ...this.state,
      isCategoryModalVisible: true
    });
  };

  renderCategoriesSelect = () => {
    const { categoryDivIsVisible } = this.state;
    const { selectedCategories, categoryList, extraSlidesInModal } = this.props;
    return (
      <div
        style={{
          display: "flex",
          marginRight: "auto",
          marginLeft: "5%"
        }}
      >
        {!extraSlidesInModal ? (
          <div
            style={{
              cursor: "pointer",
              marginTop: "8px"
            }}
            onClick={() => this.handleDisplayCategoryModal()}
          >
            <SettingIconTwo fill="#3C4E64" />
          </div>
        ) : (
          ""
        )}

        <div
          ref={this.setSelectWrapperRef.bind(this)}
          className={
            styles.customed_select +
            " " +
            (categoryDivIsVisible
              ? styles.customed_select_opened
              : styles.customed_select_closed)
          }
        >
          <div
            className={
              styles.customed_select_header +
              " " +
              styles.customed_select_header_up
            }
            onClick={this.handleDisplayCategorySelectItems}
          >
            <label>{_("categories")}</label>
          </div>
          {categoryDivIsVisible && (
            <div className={styles.customed_select_body}>
              <div className={styles.customed_select_body_items}>
                <div className={styles.customed_select_body_item} key={0}>
                  <CheckBoxBtn
                    id={0}
                    checked={selectedCategories.includes(0)}
                    onChange={() => this.handleDeselectCategory(0)}
                  />
                  <div className={styles.customed_select_body_item_label}>
                    {"non catégorisé"}
                  </div>
                </div>
                {categoryList.map((item, index) => (
                  <div className={styles.customed_select_body_item} key={index}>
                    <CheckBoxBtn
                      id={item.id}
                      checked={selectedCategories.includes(item.id)}
                      onChange={() => this.handleDeselectCategory(item.id)}
                    />
                    <div className={styles.customed_select_body_item_label}>
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  handleCancelModal = () => {
    this.setState({
      ...this.state,
      isCategoryModalVisible: false
    });
    this.props.dispatch(fetchCategoryExtraSlideList());
  };

  render() {
    const {
      extraSlides,
      visibility,
      fetching,
      handleUseExraSilde,
      extraSlidesInModal,
      withoutHeader
    } = this.props;
    return (
      <div
        className={classnames(
          styles.extra_slides,
          !extraSlidesInModal ? "page-content" : "",
          extraSlidesInModal ? styles.extraSlidesInModal : ""
        )}
      >
        {!extraSlidesInModal ? (
          <SidePageHeader
            subHeader={_("extraSlides")}
            withReturnButton={true}
            handleReturnTo={this.handleGoBack}
          />
        ) : (
          ""
        )}
        <TTPFilterHorizontalBar
          HideButton={extraSlidesInModal}
          filters={
            !extraSlidesInModal
              ? [
                  {
                    placeholder: _("visibility"),
                    options: this.visibilityOptions,
                    values: visibility,
                    action: this.handleSelectVisibility,
                    isSimple: true
                  }
                ]
              : []
          }
          searchPlaceholder="Search by title"
          ref={this.child}
          customAddOn={this.renderCategoriesSelect()}
          customAddOnFirst={true}
          handleSearchInputChange={this.handleSearchInputChange}
          cssClass={classnames(
            styles.searchClass,
            "medium-12",
            withoutHeader ? styles.without_header : ""
          )}
          fetching={fetching}
        />

        <ExtraSlideList handleUseExraSilde={handleUseExraSilde} />
        {!extraSlidesInModal ? (
          <TTPModal
            visible={this.state.isCategoryModalVisible}
            footer={null}
            width={900}
            closable={false}
          >
            <CategorySettingContent
              onCancel={this.handleCancelModal}
              loading={this.state.loading}
            />
          </TTPModal>
        ) : (
          ""
        )}

        <div>
          {extraSlides && extraSlides.length ? (
            this.renderPaginate()
          ) : (
            <div className="row pagination" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetched: state.extraSlideList.fetched,
  fetching: state.extraSlideList.fetching,
  organizationUen: state.auth.currentOrganization.uen,
  nbResult: state.extraSlideList.nbResult,
  paginationPage: state.extraSlideList.paginationPage,
  pageSize: state.extraSlideList.pageSize,
  visibility: state.extraSlideList.filter.visibility,
  searchTitle: state.extraSlideList.filter.searchTitle,
  categoryListSelected: state.extraSlideList.filter.category,
  extraSlides: state.extraSlideList.extraSlides,
  selectedCategories: state.extraSlideList.filter.category,
  categoryList: state.extraSlideList.categorySettings.categoryList,
  extraSlidesInModal: state.preparePresentation.extraSlidesInModal,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(ExtraSlidesContentPage);



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/ExtraSlidesContentPage.js